import { SearchParam } from '../../types/state'
import { safeDecodeUriComponent } from './safeDecodeUriComponent'

export const parseQuery = (queryString): SearchParam => {
    const query = {} as SearchParam

    if (!queryString) {
        return query
    }

    const pairs = (
        queryString[0] === '?' ? queryString.substr(1) : queryString
    ).split('&')

    pairs.forEach((p) => {
        const pair = p.split('=')
        query[safeDecodeUriComponent(pair[0])] = safeDecodeUriComponent(
            pair[1] || '',
        )
    })

    return query
}
